import { createStyles, Theme } from "@material-ui/core";

export default (theme: Theme) => createStyles({
    selector: {
        width: '100%',
        marginTop: theme.spacing(2),
        textAlign: 'initial'
    }
});